import { render, staticRenderFns } from "./ProductShowcase.vue?vue&type=template&id=86de0f7c&"
import script from "./ProductShowcase.vue?vue&type=script&lang=ts&"
export * from "./ProductShowcase.vue?vue&type=script&lang=ts&"
import style0 from "./ProductShowcase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports